<template>
  <div style="border-radius: 1rem">
    <table
      v-if="testcases.length > 0"
      class="w-full border shadow-lg text-gray-800 border-primary-50 dark:text-dark-text dark:bg-dark-400 dark:border-dark-400 border-separate border-spacing-0"
      style="border-radius: 1rem"
    >
      <thead class="w-full text-white">
        <tr class="grid grid-cols-8 text-sm">
          <th
            class="border-r py-2 flex justify-center items-center bg-primary border-primary-400 dark:border-dark-400 dark:bg-dark-400"
            style="border-radius: 1rem 0 0 0"
          >
            {{ $t('message.case') }}
          </th>
          <th
            class="border-r flex justify-center items-center bg-primary border-primary-400 dark:border-dark-400 dark:bg-dark-400"
          >
            {{ $t('message.status') }}
          </th>
          <th
            class="border-r flex justify-center items-center bg-primary border-primary-400 dark:border-dark-400 dark:bg-dark-400"
          >
            {{ $t('message.time') }}
          </th>
          <th
            class="border-r flex justify-center items-center bg-primary border-primary-400 dark:border-dark-400 dark:bg-dark-400"
          >
            {{ $t('message.memory') }}
          </th>
          <th
            class="border-r flex justify-center items-center bg-primary border-primary-400 dark:border-dark-400 dark:bg-dark-400"
          >
            {{ $t('message.input') }}
          </th>
          <th
            class="border-r flex justify-center items-center bg-primary border-primary-400 dark:border-dark-400 dark:bg-dark-400"
          >
            {{ $t('message.output') }}
          </th>
          <th
            class="border-r flex justify-center items-center bg-primary border-primary-400 dark:border-dark-400 dark:bg-dark-400"
          >
            {{ $t('message.caseName') }}
          </th>
          <th
            class="flex justify-center items-center bg-primary border-primary-400 dark:border-dark-400 dark:bg-dark-400"
            style="border-radius: 0 1rem 0 0"
          >
            {{ $t('message.casePaste') }}
          </th>
        </tr>
      </thead>
      <tbody class="border-l border-r border-primary-50 dark:border-dark-400" style="border-radius: 1rem">
        <transition-group appear name="table-row">
          <tr v-for="(tc, index) in testcases" :key="tc.serial" class="grid" :style="`--delay-time: ${index * 100}ms`">
            <div class="grid grid-cols-8">
              <td
                class="border-r border-t flex justify-center border-primary-50 dark:border-dark-400 dark:bg-dark-500"
                :class="isHideJudgeCaseList[index] ? 'border-b' : ''"
                :style="
                  !isHideJudgeCaseList[index] && index == testcases.length - 1 ? { borderRadius: '0 0 0 1rem' } : {}
                "
              >
                <button class="text-blue-500 focus:outline-none hover:underline" @click="clickJudgeCase(index)">
                  {{ tc.label }}
                </button>
              </td>
              <td
                class="border-r border-t flex justify-center items-center p-1 border-primary-50 dark:border-dark-400 dark:bg-dark-500"
                :class="isHideJudgeCaseList[index] ? 'border-b' : ''"
              >
                <span v-if="!tc.status" class="text-gray-600"> - </span>
                <judge-badge v-else :status="status(tc.status)" />
              </td>
              <td
                class="border-r border-t flex justify-center items-center text-center p-1 border-primary-50 dark:border-dark-400 dark:bg-dark-500"
                :class="isHideJudgeCaseList[index] ? 'border-b' : ''"
              >
                {{ tc.cpuTime == null ? '' : (tc.cpuTime / 100).toFixed(2) }}
                sec
              </td>
              <td
                class="border-r border-t flex justify-center items-center p-1 text-center border-primary-50 dark:border-dark-400 dark:bg-dark-500"
                :class="isHideJudgeCaseList[index] ? 'border-b' : ''"
              >
                {{ tc.memory }} KB
              </td>
              <td
                class="border-r border-t flex justify-center items-center p-1 text-center border-primary-50 dark:border-dark-400 dark:bg-dark-500"
                :class="isHideJudgeCaseList[index] ? 'border-b' : ''"
              >
                {{ tc.inputSize }} B
              </td>
              <td
                class="border-r border-t flex justify-center items-center p-1 text-center border-primary-50 dark:border-dark-400 dark:bg-dark-500"
                :class="isHideJudgeCaseList[index] ? 'border-b' : ''"
              >
                {{ tc.outputSize }} B
              </td>
              <td
                class="flex justify-center items-center border-r border-t p-1 text-center border-primary-50 dark:border-dark-400 dark:bg-dark-500"
                :class="isHideJudgeCaseList[index] ? 'border-b' : ''"
              >
                <p
                  class="mx-2"
                  style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; text-align: center"
                >
                  {{ tc.caseName }}
                </p>
              </td>
              <td
                class="justify-center flex border-t p-1 border-primary-50 dark:border-dark-400 dark:bg-dark-500"
                :class="isHideJudgeCaseList[index] ? 'border-b' : ''"
                :style="
                  !isHideJudgeCaseList[index] && index == testcases.length - 1 ? { borderRadius: '0 0 1rem 0' } : {}
                "
              >
                <button
                  v-if="
                    (judgeCaseList[index].in != 'It\'s large data. Please download it.' &&
                      judgeCaseList[index].in != 'JudgeCase is not available.') ||
                    (judgeCaseList[index].out != 'It\'s large data. Please download it.' &&
                      judgeCaseList[index].out != 'JudgeCase is not available.')
                  "
                  class="material-icons focus:outline-none hover:text-blue-500"
                  :data-tooltip="$t('message.pasted')"
                  @click="pasteCase(index)"
                >
                  content_paste
                </button>
                <span v-else class="material-icons"> clear </span>
              </td>
            </div>
            <div v-if="judgeCaseList" class="dark:bg-dark-500" style="border-radius: 0 0 1rem 1rem">
              <div v-if="isHideJudgeCaseList[index]">
                <div class="grid grid-cols-2">
                  <label class="mx-6 mt-3">{{ $t('message.input') }}</label>
                  <label class="mx-6 mt-3">{{ $t('message.output') }}</label>
                </div>
                <div class="grid grid-cols-2">
                  <td class="flex justify-center testCaseText">
                    <input-area
                      id="user-input"
                      class="mt-2 rounded border border-gray-300 bg-gray-200 text-gray-800 dark:border-dark-200 dark:bg-dark-400 dark:text-dark-text"
                      :isEditable="false"
                      :value="judgeCaseList[index].in"
                    />
                  </td>
                  <td class="flex justify-center testCaseText">
                    <input-area
                      id="expected-output"
                      class="mt-2 rounded border border-gray-300 bg-gray-200 text-gray-800 dark:border-dark-200 dark:bg-dark-400 dark:text-dark-text"
                      :isEditable="false"
                      :value="judgeCaseList[index].out"
                    />
                  </td>
                </div>
                <div class="grid grid-cols-2">
                  <button
                    class="copyButton text-sm border flex items-center justify-center rounded py-1 pr-2 transform duration-150 focus:outline-none"
                    style="width: 130px"
                    @click="clickDownload(index, false)"
                  >
                    <span class="material-icons"> file_download </span>
                    <span>{{ $t('message.download') }}</span>
                  </button>
                  <button
                    class="copyButton text-sm border flex items-center justify-center rounded py-1 pr-2 transform duration-150 focus:outline-none"
                    style="width: 130px"
                    @click="clickDownload(index, true)"
                  >
                    <span class="material-icons">file_download</span>
                    <span>{{ $t('message.download') }}</span>
                  </button>
                </div>
              </div>
            </div>
          </tr>
        </transition-group>
      </tbody>
    </table>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'

import InputArea from './InputArea.vue'

import { convertJudgeStatusType } from '@/domain/value_objects/judge/JudgeStatusType'
import JudgeBadge from '@/presentation/components/Text/JudgeBadge.vue'
import { useEditorPageStatePresenter } from '@/presentation/composables/editor/useEditorPageStatePresenter'
import { useFrameStatePresenter } from '@/presentation/composables/frame/useFrameStatePresenter'
import { useJudgeDetailPresenter } from '@/presentation/composables/judge/useJudgeDetailPresenter'
import { useJudgeStatePresenter } from '@/presentation/composables/judge/useJudgeStatePresenter'
import { useJudgeDetailPageStatePresenter } from '@/presentation/composables/judgeDetail/useJudgeDetailPageStatePresenter'
import { useProblemStatePresenter } from '@/presentation/composables/problem/useProblemStatePresenter'
import { useJudgeCasePresenter } from '@/presentation/composables/testCase/useJudgeCasePresenter'
import { useTestCasePresenter } from '@/presentation/composables/testCase/useTestCasePresenter'

export default defineComponent({
  components: {
    JudgeBadge,
    InputArea
  },
  setup(props, ctx) {
    const { judgeDetail } = useJudgeDetailPresenter()
    const { isJudgeLoading, setTestInput, setTestOutput } = useJudgeStatePresenter()
    const { testCaseList } = useTestCasePresenter()
    const { judgeCaseList } = useJudgeCasePresenter()
    const { setIsPastingIOConsole } = useEditorPageStatePresenter()
    const { isHideJudgeCaseList, reverseFlagIsHideJudgeCaseList, downloadTestCase } = useJudgeDetailPageStatePresenter()
    const { setRightSideFrame } = useFrameStatePresenter()
    const { problemId } = useProblemStatePresenter()

    const testcases = computed(() => (judgeDetail.value && !isJudgeLoading.value ? judgeDetail.value.caseVerdicts : []))

    const status = (x: string) => convertJudgeStatusType(x)

    const clickJudgeCase = (index: number) => {
      reverseFlagIsHideJudgeCaseList(index)
    }

    const pasteCase = (index: number) => {
      setTestInput(judgeCaseList.value[index].in)
      setTestOutput(judgeCaseList.value[index].out)
      setIsPastingIOConsole(true)
      setRightSideFrame('Editor')
    }

    const clickDownload = (index: number, isOutput: boolean) => {
      downloadTestCase(problemId.value, index + 1, isOutput)
    }

    return {
      status,
      clickJudgeCase,
      isHideJudgeCaseList,
      pasteCase,
      clickDownload,
      testcases,
      judgeCaseList,
      testCaseList
    }
  }
})
</script>

<style lang="postcss" scoped>
.my-justify-items-stretch {
  justify-items: stretch;
}

.table-row-enter-active {
  transition: all 0.2s ease var(--delay-time);
}

.table-row-enter-from {
  opacity: 0;
  transform: translateY(10px);
}

.my-transition {
  transition-delay: var(--delay-time, 500s);
}

.testCaseText {
  margin: 0px 20px 10px 20px;
}

.copyButton {
  margin: 0px 0px 10px 20px;
}
.box:last-child {
  margin-bottom: 16px;
}

.hover-paste {
  text-decoration: none;

  @apply relative inline-block;

  &::before {
    content: '';
    top: -15px;
    left: 50%;
    transform: translateX(-50%);
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 8px solid #232a3b;
    @apply block absolute fadein;
  }

  &::after {
    font-family: sans-serif;
    content: attr(data-tooltip);
    bottom: 155%;
    left: 50%;
    transform: translateX(-50%);
    @apply bg-aoj text-white rounded px-2 py-1 block absolute font-bold text-sm pointer-events-none z-10 fadein;
  }
}

.fadein {
  opacity: 1;
  animation-name: fadeout;
  animation-duration: 1s;
  animation-fill-mode: forwards;
  animation-delay: 1s;
}

@keyframes fadeout {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.click-effect:active {
  @apply border-gray-900 bg-gray-200;
}

.click-effect-dark:active {
  @apply bg-dark-10;
}
</style>
